function crudListAppendButton() {
  return {
    scope: {
      action: '&'
    },
    template: '<button type="button" class="btn btn-success" ng-click="action()">Add</button>'
  };
}

export default crudListAppendButton;



/** WEBPACK FOOTER **
 ** ./src/app/crud/list-append-button.directive.js
 **/